<template lang="pug">
  .balance-files
    .toolbar
      .mobile-title
        span.mobile-title__number.semibold 06
        span Баланс количественных характеристик
      .toolbar__line
        h1.title Баланс количественных характеристик
    .content.max-height-initial
      .files
        .files__items
          .files__item(v-for='item in files')
            a.files__link(
              :key="item.id"
              download
              :href="'/files/balance/'+item.file"
            ) {{item.name}}
</template>

<script>
import files from './data/files'

export default {
  name: 'balance-files',
  data: () => ({
    files,
  }),
}
</script>
